﻿import Box from '@mui/material/Box';
import React, { ChangeEvent } from 'react';
import TextField from '../../../../../../../temp/TextField';

type LinkInputProps = {
    placeholder: string;
    name: string;
    onChange: (link: string) => void;
};

function LinkInput({ placeholder, name, onChange }: LinkInputProps) {
    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        event.persist();
        onChange(event.target.value);
    }
    return (
        <Box sx={{ padding: '8px' }}>
            <TextField
                placeholder={placeholder}
                type="text"
                name={name}
                sx={{ width: '100%' }}
                onChange={handleChange}
            />
        </Box>
    );
}

export default LinkInput;
